import React, { useState } from "react";
import "./ContextSidebar.css";

const ContextSidebar = ({ otherUserInfo }) => {
  const [tasks, setTasks] = useState([
    {
      id: 1,
      title: "Lorem ipsum dolor sit amet",
      status: "Xong",
      assignedTo: ["user1", "user2"],
      deadline: "17 tháng 7, 2025",
    },
    {
      id: 2,
      title: "Lorem ipsum dolor sit amet",
      status: "Xong",
      assignedTo: ["user1"],
      deadline: "17 tháng 7, 2025",
    },
  ]);

  const [description, setDescription] = useState(
    "Mô tả Lorem ipsum dolor sit amet, consetetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  );
  const [isEditingDescription, setIsEditingDescription] = useState(false);

  const handleAddTask = () => {
    const newTask = {
      id: Date.now(),
      title: "Công việc mới",
      status: "Đang làm",
      assignedTo: ["user1"],
      deadline: new Date().toLocaleDateString("vi-VN"),
    };
    setTasks([...tasks, newTask]);
  };

  return (
    <div className="context-sidebar">
      {/* Mô tả Section */}
      <div className="sidebar-section">
        <div className="section-header">
          <h3 className="section-title">Mô tả</h3>
          <button
            className="edit-btn"
            onClick={() => setIsEditingDescription(!isEditingDescription)}
            title="Chỉnh sửa mô tả"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L5.33301 13.3334L1.66634 14.3334L2.66634 10.6667L11.333 2.00004Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        {isEditingDescription ? (
          <textarea
            className="description-textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onBlur={() => setIsEditingDescription(false)}
            rows={4}
          />
        ) : (
          <p className="description-text">{description}</p>
        )}
      </div>

      {/* Công việc Section */}
      <div className="sidebar-section">
        <div className="section-header">
          <h3 className="section-title">Công việc</h3>
          <button
            className="add-task-btn"
            onClick={handleAddTask}
            title="Thêm công việc"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 3V13M3 8H13"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className="tasks-list">
          {tasks.map((task) => (
            <div key={task.id} className="task-card">
              <div className="task-header">
                <p className="task-title">{task.title}</p>
                <span className="task-status">{task.status}</span>
              </div>
              <div className="task-footer">
                <div className="task-assignees">
                  {task.assignedTo.map((user, index) => (
                    <div key={index} className="assignee-avatar">
                      <div className="assignee-placeholder">
                        {user.charAt(0).toUpperCase()}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="task-deadline">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="2"
                      y="3"
                      width="10"
                      height="9"
                      rx="1"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M2 6H12M5 1V3M9 1V3"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                  <span className="deadline-text">{task.deadline}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContextSidebar;
